import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const NAMES = ['María Laura', 'Claudia', 'Patricia', 'Gabriela', 'Silvia', 'Andrea', 'Carolina', 'Luciana', 'Valeria', 'Fernanda'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    const triggerPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1;
      setData({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Hide after 4 seconds
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(triggerPopup, 5000);
    // Subsequent popups every 15-30 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        triggerPopup();
      }
    }, Math.random() * 15000 + 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-214">
      {isVisible && <motion.div initial={{
      x: -400,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -400,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 15
    }} className="fixed bottom-4 left-4 z-40 max-w-sm w-[calc(100%-2rem)] md:w-auto" data-id="element-215">
          <div className="bg-zinc-900 border-l-4 border-yellow-500 rounded-lg shadow-2xl p-4 flex items-start gap-4" data-id="element-216">
            <div className="w-10 h-10 rounded-full bg-yellow-500 flex items-center justify-center text-black font-bold text-lg flex-shrink-0" data-id="element-217">
              {data.name.charAt(0)}
            </div>
            <div data-id="element-218">
              <div className="flex items-center gap-1.5 mb-1" data-id="element-219">
                <p className="text-white font-medium text-sm" data-id="element-220">{data.name}</p>
                <span className="text-gray-500 text-xs" data-id="element-221">de {data.city}</span>
              </div>
              <p className="text-gray-300 text-sm mb-1.5" data-id="element-222">
                Compró el Sistema Completo
              </p>
              <div className="flex items-center gap-1.5" data-id="element-223">
                <CheckCircle2Icon className="w-3.5 h-3.5 text-green-500" data-id="element-224" />
                <span className="text-green-500 text-xs font-medium" data-id="element-225">
                  Compra verificada
                </span>
                <span className="text-gray-500 text-xs ml-1" data-id="element-226">
                  Hace {data.time} min
                </span>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}